import { useState } from 'react';
import { useNavigate } from 'react-router';
import type { Account } from '@/api/commercial/accounts';
import { StepClientShared } from '@/components/commercial/proposals/shared/step-client-shared';
import { useProposalNavigation } from '@/components/commercial/proposals/shared/use-proposal-navigation';
import { useCreateProposal } from '@/context/create-proposal-context';
import { useToast } from '@/hooks/use-toast';
import { AccountCreateModal } from './account-create-modal';
import { AccountEditModal } from './account-edit-modal';

export function StepClientContainer() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const navigation = useProposalNavigation({ mode: 'create' });

  const {
    account,
    contacts,
    selectedContactIds,
    setAccount,
    setContacts,
    toggleContactSelection,
    createProposalApi,
    proposal,
  } = useCreateProposal();

  const [createAccountModalOpen, setCreateAccountModalOpen] = useState(false);
  const [editAccountModalOpen, setEditAccountModalOpen] = useState(false);

  const handleNextStep = async () => {
    if (!account) {
      toast({
        title: 'Erro',
        description: 'Selecione um cliente antes de continuar.',
        variant: 'destructive',
      });
      return;
    }

    if (selectedContactIds.size === 0) {
      toast({
        title: 'Erro',
        description: 'Selecione pelo menos um contato antes de continuar.',
        variant: 'destructive',
      });
      return;
    }

    const result = await createProposalApi();

    if (result.success) {
      navigation.goToCreditAnalysis();
    }
  };

  const handleBack = () => {
    navigate('/commercial/proposal');
  };

  const handleAccountCreated = (newAccount: Account) => {
    setAccount(newAccount);
    toast({
      variant: 'success',
      title: 'Conta criada',
      description: 'A conta foi criada e selecionada automaticamente.',
    });
  };

  const handleAccountEditSuccess = async (updatedAccount: Account) => {
    setAccount(updatedAccount);
  };

  const handleEditAccount = () => {
    setEditAccountModalOpen(true);
  };

  return (
    <>
      <StepClientShared
        account={account}
        contacts={contacts}
        selectedContactIds={selectedContactIds}
        proposalId={proposal?.id}
        isUpdate={false}
        onAccountChange={setAccount}
        onContactsChange={setContacts}
        onContactSelectionChange={toggleContactSelection}
        onNextStep={handleNextStep}
        onBack={handleBack}
        onCreateAccount={() => setCreateAccountModalOpen(true)}
        onEditAccount={handleEditAccount}
      />

      {/* Account Create Modal */}
      <AccountCreateModal
        open={createAccountModalOpen}
        onClose={() => setCreateAccountModalOpen(false)}
        onSuccess={handleAccountCreated}
      />

      {/* Account Edit Modal */}
      <AccountEditModal
        open={editAccountModalOpen}
        onClose={() => setEditAccountModalOpen(false)}
        account={account}
        onSuccess={handleAccountEditSuccess}
      />
    </>
  );
}
